import { useEffect } from 'react'

// Pure decision: is `target` outside the popover? When `wrapSelector` is given,
// a target sharing the panel's nearest wrapper (e.g. the trigger button, a
// sibling of the panel inside .cn-popover-wrap) counts as INSIDE — so clicking
// an open trigger doesn't fire outside-close then let the trigger re-open it.
export function isOutside(target, panelEl, wrapSelector) {
  if (!panelEl) return false
  if (panelEl.contains && panelEl.contains(target)) return false
  if (wrapSelector && target && target.closest) {
    const panelWrap = panelEl.closest ? panelEl.closest(wrapSelector) : null
    if (panelWrap && target.closest(wrapSelector) === panelWrap) return false
  }
  return true
}

// Close a popover when clicking outside `ref` or pressing Escape.
// Pass the open flag so the listeners are only attached while open.
// opts.wrapSelector: treat clicks inside the panel's nearest matching wrapper
// (i.e. the trigger) as inside — see isOutside.
export default function useOutsideClose(ref, open, onClose, opts = {}) {
  const { wrapSelector } = opts
  useEffect(() => {
    if (!open) return undefined
    const onDown = (e) => { if (isOutside(e.target, ref.current, wrapSelector)) onClose() }
    const onKey = (e) => { if (e.key === 'Escape') onClose() }
    const id = setTimeout(() => {
      document.addEventListener('mousedown', onDown)
      document.addEventListener('keydown', onKey)
    }, 0)
    return () => {
      clearTimeout(id)
      document.removeEventListener('mousedown', onDown)
      document.removeEventListener('keydown', onKey)
    }
  }, [ref, open, onClose, wrapSelector])
}
